import { render, staticRenderFns } from "./RentalCardV2.vue?vue&type=template&id=b30b2138&scoped=true"
import script from "./RentalCardV2.vue?vue&type=script&lang=js"
export * from "./RentalCardV2.vue?vue&type=script&lang=js"
import style0 from "./RentalCardV2.vue?vue&type=style&index=0&id=b30b2138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30b2138",
  null
  
)

export default component.exports